"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _index = require("./index.js");
var _PermissionForm = _interopRequireDefault(require("./PermissionForm"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TableRenderPawnPermissionEdit = function TableRenderPawnPermissionEdit(_ref) {
  var row = _ref.row,
    loadData = _ref.loadData;
  var initialValues = {};
  _index.permissionsData.forEach(function (p) {
    var hasPawnPerm = !!row["".concat(p.alias, "PawnPerm.permission")];
    hasPawnPerm = hasPawnPerm && !!row["".concat(p.alias, "PawnPerm.targetId")];
    initialValues[p.permission] = hasPawnPerm;
  });
  var username = row['user.username'];
  var firstName = row['user.firstName'];
  var lastName = row['user.lastName'];
  var fullName = firstName && lastName ? "".concat(firstName, " ").concat(lastName) : "".concat(firstName).concat(lastName);
  var modalHeaderText = fullName ? "".concat(fullName, " (").concat(username, ")") : username;
  return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Edit Permissions"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    trigger: /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_pencil["default"], null),
      className: "btn btn-xs btn-success"
    }),
    title: "Edit Permissions",
    render: function render(_ref2) {
      var closeModal = _ref2.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].modalHeader
      }, "Editing Permissions for ", /*#__PURE__*/_react["default"].createElement("strong", null, modalHeaderText)), /*#__PURE__*/_react["default"].createElement(_PermissionForm["default"], {
        closeModal: closeModal,
        initialValues: initialValues,
        loadData: loadData,
        pawnIds: [row['pawn.pawnId']]
      }));
    }
  }));
};
var _default = exports["default"] = TableRenderPawnPermissionEdit;